export default __webpack_public_path__ + "static/LAPTOPANDPHONE_TRANSPARENT-88aa3b71a62731766dca162833bbb0cd.png";